var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCavetUp = function SvgCavetUp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C5F94F3E-E4A0-4162-B995-A71B83C1A1B7@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with sketchtool.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M28.653 19.814 17.718 8.526a1 1 0 0 0-1.436 0L5.347 19.814a2.945 2.945 0 0 1-4.232-.002l-.1-.104a3 3 0 0 1 0-4.17L14.843 1.233a3 3 0 0 1 4.314 0l13.828 14.307a3 3 0 0 1 0 4.17l-.1.103a2.945 2.945 0 0 1-4.232.002"
  })));
};
export default SvgCavetUp;